import { useEffect } from 'react';
import { formatTime } from '../../../../../../../core/commom/formatTime';
import { BadgeScore } from '../../../../../../../core/components/atoms/BadgeScore';
import { Button } from '../../../../../../../core/components/atoms/Button';
import {
  Tag,
  TagVariant,
} from '../../../../../../../core/components/atoms/Tag';
// import { Tag } from "../../../../../../../core/components/atoms/Tag";
import { Typography } from '../../../../../../../core/components/molecules/Typography';
import { ContentActions } from '../../../../../../../core/components/organism/ContentActions';
import { useLessonNotesPdf } from '../../../../../../../core/components/organism/Lesson/hooks/useLessonNotesPdf';
import { useShouldShowPopUpScore } from '../../../../../../../core/hooks/useShouldShowPopUpScore';
import { useUserStore } from '../../../../../../Auth/stores/authStore';
import useGetBadgeScores from '../../../../../../Disciplines/hooks/useGetBadgeScores';
import { IPALessonDto } from '../../../../../model/dailySchedule';

//TODO: Handle the incidence tag.
interface ITitleSectionProps {
  lesson: IPALessonDto;
}

function TitleSection({ lesson }: ITitleSectionProps) {
  const { user } = useUserStore();
  const { shouldShowBadgeScore } = useShouldShowPopUpScore();
  const {
    getBadgeScores,
    badgeScore,
    isPending: isPendingBadgeScores,
  } = useGetBadgeScores();

  // Mesma lógica de geração assíncrona das anotações usada nas Disciplinas:
  // usa `notesPdfUri` direto quando já existe; caso contrário dispara o
  // `POST /lessons/:id/notes-pdf` e faz polling até o PDF ficar pronto.
  const {
    openNotesPdf,
    isLoading: isNotesPdfLoading,
    isReady: isNotesPdfReady,
  } = useLessonNotesPdf(lesson?.id ?? '', true, lesson?.notesPdfUri);

  if (!lesson) {
    return null;
  }

  useEffect(() => {
    if (user?.id) {
      getBadgeScores({
        externalId: user?.id,
        externalContent: lesson.id,
        externalContentOrigin: 'plano-adaptativo',
      });
    }
  }, [lesson, user?.id]);

  const shouldBadgeScore = shouldShowBadgeScore && !isPendingBadgeScores;

  return (
    <div className='flex flex-col justify-between gap-xs md:flex-row'>
      <div className='flex flex-col md:items-center gap-sm md:flex-row'>
        <div className='flex flex-col gap-sm '>
          <Typography size='h3' type='title'>
            {lesson.title}
          </Typography>
          <div className='flex flex-row items-center justify-between'>
            <div className='flex flex-row items-center gap-lg'>
              <Tag variant={`incidencia${lesson.incidence}` as TagVariant}>
                Incidência {lesson.incidence}
              </Tag>
              <Typography size='small' className='text-mono-color-darker'>
                {`${formatTime(lesson.duration)} Prof. ${lesson.teacher.map((t) => t.name).join(', ')}`}
              </Typography>
            </div>
          </div>
        </div>
        <div className='flex max-w-fit'>
          {shouldBadgeScore && (
            <BadgeScore score={badgeScore?.didPoint ? badgeScore?.points : 5} />
          )}
        </div>
      </div>

      <div className='flex flex-row items-center gap-xxl'>
        <Button
          variant='text'
          LeftIcon='open_in_new'
          iconType='material'
          className='p-0'
          loading={isNotesPdfLoading}
          disabled={!isNotesPdfReady}
          onClick={openNotesPdf}
        >
          Abrir anotações
        </Button>
        <ContentActions.Root
          contentId={lesson.id}
          contentSlug={lesson.slug}
          contentType='Lesson'
          className={'gap-xxl'}
        >
          <ContentActions.ReviewButtons defaultReview={lesson.review} />
          <ContentActions.FavoriteButton
            category='lesson'
            defaultFavorite={lesson.favorite}
          />
          <ContentActions.Report />
        </ContentActions.Root>
      </div>
    </div>
  );
}

export default TitleSection;
